export default "__VITE_ASSET__CHmhxWOA__"